import classNames from 'classnames'

import Image from '../ui/Image/Image'
import MediaPlayer from '../ui/MediaPlayer/MediaPlayer'
import ProductCards from '../ProductCards/ProductCards'
import Button from '../ui/Button/Button'
import { getUrl } from '../../utils'

import arrow from '../../assets/images/arrow.svg'
import styles from './CardsWithMediaPlayer.module.scss'

function CardsWithMediaPlayer({
  selectedCard,
  cards,
  cardClickHandler,
  handleReadMoreClick,
  className,
  buttonText = '',
  hideVideo,
}) {
  return (
    <div className={classNames(styles.videoContianer, className)}>
      {selectedCard?.video && !hideVideo ? (
        selectedCard?.video?.mime.includes('video') ? (
          <MediaPlayer
            src={getUrl(selectedCard?.video || '')}
            className={styles.innerContainer}
            mute={true}
            preload={'auto'}
            play={true}
            videoClass={styles.video}
          />
        ) : (
          <Image
            src={getUrl(selectedCard?.video)}
            alt={selectedCard?.video?.alternativeText}
            className={styles.image}
          />
        )
      ) : null}
      <div
        className={classNames(styles.controlsContainer, {
          [styles.hideVideoContainer]: hideVideo,
        })}
      >
        <ProductCards
          cards={cards}
          selectedCard={selectedCard}
          cardClickHandler={cardClickHandler}
          className={styles.cardsContainer}
          cardClass={classNames(styles.cardClass, {
            [styles.cursorDefault]: cards?.length === 1,
          })}
        />
        <Button
          classname={styles.button}
          text={buttonText}
          handleClick={handleReadMoreClick}
          aria-label={buttonText}
        >
          <Image src={arrow} alt={buttonText} className={styles.btnImage} />
        </Button>
      </div>
    </div>
  )
}

export default CardsWithMediaPlayer
